const batteryShippingFormAgreementMd = `
## 〜【補充禁止】 バッテリーの発送〜
<br>

------

### ■対象バッテリー
・故障しているバッテリー

・BLPBとして取り出したバッテリー(一部の方に開放)

### ■報酬

・税込70 円（税抜63.6円）/個

### ■発送方法
・郵送（追跡番号付き）

・持ち込み（築地オフィス 24時間）

### ■郵送の詳細

差出氏名：【SpotWORK＋氏名】としてください

発送方法：追跡番号つきであること

梱包方法：段ボール

品名　　：モバイルバッテリー（のみの記載でOK）

送料負担：元払い限定（送料は報酬に含まれる）

発送住所：<br>〒136-0083 江東区若洲2-2-3<br>SBSロジコム 若洲物流センター<br>INFORICH配送センター宛

### ■注意点
・補充禁止バッテリーと補充用バッテリーは一緒に送れません<br>→送り先が異なります

・着払いは受け取れません

------
<br>
  `
  export { batteryShippingFormAgreementMd }
